import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type FinderApplicationPrivateModuleSpecsFragment } from '../../../../api/fragments/FinderApplicationPrivateModuleSpecs';
// eslint-disable-next-line max-len
import { type FinderApplicationPublicModuleSpecsFragment } from '../../../../api/fragments/FinderApplicationPublicModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

export type FinderApplicationModuleActionsProps = {
    module: FinderApplicationPublicModuleSpecsFragment | FinderApplicationPrivateModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const FinderApplicationModuleActions = ({ module, permissions }: FinderApplicationModuleActionsProps) => {
    const { t } = useTranslation(['finderApplicationModuleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('finderApplicationModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown overlay={<Menu items={items} />}>
            <Button type="primary">
                <Space>
                    <span>{t('finderApplicationModuleDetails:mainActionButtons.actions')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default FinderApplicationModuleActions;
